import { Text, View } from '@react-pdf/renderer';
import { paymentDataStyles } from './paymentDataStyles';

const { paymentData } = paymentDataStyles();


const PaymentConcept = ({ title, data,isLast }: any) => {
    return (
        <View style={[paymentData.subContainer, { borderRightWidth : isLast ? 0 : 1 }]} >
            <View>
                <Text style={{fontSize: 5,fontWeight: 700}}>{title || ' '}</Text>
            </View>
            <View>
                <Text style={{fontSize: 5}}> {data || ' '}</Text>
            </View>
        </View>
    );
};

export const PaymentData = ({ data, showTranslatedText }: any) => {
    return (
        <View fixed style={paymentData.container}>
            <PaymentConcept
                title={`${showTranslatedText("reports.salesInvoicePdf.paymentData.CFDIUse")}:`}
                data={`${data.dataInvoiceGeneral.cfdi_code || ""} ${data.dataInvoiceGeneral.cfdi_description || " "}`}
            />
            <PaymentConcept
                title={`${showTranslatedText("reports.salesInvoicePdf.paymentData.methodPayment")}:`}
                data={`${data.dataInvoiceGeneral.payment_mode_code || ""} - ${data.dataInvoiceGeneral.payment_mode_description || " "}`}
            />
            <PaymentConcept
                title={`${showTranslatedText("reports.salesInvoicePdf.paymentData.paymentConditions")}:`}
                data={data.dataInvoiceGeneral.payment_condition_name}
            />
            <PaymentConcept
                title={`${showTranslatedText("reports.salesInvoicePdf.paymentData.paymentType")}:`}
                data={`${data.dataInvoiceGeneral.payment_method_code || ""} - ${data.dataInvoiceGeneral.payment_method_name || " "}`}
                isLast={true}
            />
        </View>
    )
}
